import { useEffect, useState } from "react";
import { useLocalStorage } from "./storage.hook";
import { User } from "src/models/user";

export const useUser = () => {
    const { setObject, getObject } = useLocalStorage();
    const [user, setUser] = useState<User | null>(getObject('user'));
    const [account, setAccount] = useState<any>(getObject('account'));

    useEffect(() => {
        setUser(getObject('user'));
        setAccount(getObject('account'));
    }, [])

    const addUser = (user: User) => {
        setUser(user);
        setObject("user", user);
    };
    const addAccount = (account: any) => {
      setAccount(account);
      setObject("account", account);
  };

    return { user, addUser, account, addAccount };
};